module.exports = __webpack_public_path__ + "static/img/HeNan_jianjiePic_autumn.98da6e00.png";